// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_i5-0";